import PropTypes from 'prop-types';
import { AutocompleteInput, Form, ReferenceInput, useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import { deviceFilterToQuery } from '@/helpers/filters/filterToQuery.js';
import { getDeviceOptionText } from '@/helpers/parameter/parameterSubsetDisplay.js';

const deviceOptionText = choice => {
    if (choice == null || choice === '') {
        return '';
    }

    if (typeof choice !== 'object') {
        return String(choice);
    }

    return getDeviceOptionText(choice);
};

export const DeviceConfigDeviceSelect = ({ deviceId, onChange }) => {
    const translate = useTranslate();

    return (
        <Form key={deviceId ?? 'empty'} defaultValues={{ deviceId: deviceId ?? null }} onSubmit={() => {}} className='device-config-select-form'>
            <Box className='autocomplete-parent device-config-select'>
                <ReferenceInput source='deviceId' reference='device' perPage={25} filter={{ withAggregates: true }}>
                    <AutocompleteInput
                        optionText={deviceOptionText}
                        inputText={deviceOptionText}
                        filterToQuery={deviceFilterToQuery}
                        label={translate('resources.device.fields.serialNumber')}
                        onChange={(_, value) => onChange(value?.id ?? value ?? null)}
                        fullWidth
                        disablePortal
                        noOptionsText={translate('common.noResults')}
                    />
                </ReferenceInput>
            </Box>
        </Form>
    );
};

DeviceConfigDeviceSelect.propTypes = {
    deviceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
};
